// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Импорт переводов
import enTranslations from "../public/locales/en/translations.json";
import ruTranslations from "../public/locales/ru/translations.json";
import arTranslations from "../public/locales/ar/translations.json"; // Добавляем арабский

const resources = {
  en: {
    translation: enTranslations,
  },
  ru: {
    translation: ruTranslations,
  },
  ar: {
    // Добавляем ресурсы для арабского
    translation: arTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "ru",
    supportedLngs: ["en", "ru", "ar"],
    load: "languageOnly",
    detection: {
      order: [
        "path",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "subdomain",
      ],
      lookupFromPathIndex: 0,
      caches: ["cookie", "localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
